const selectors = {
  vehiclesContainer: '[data-comp-preview-panel-vehicles]',
  vehiclesList: '[data-comp-preview-panel-vehicles-list]',
};

const classes = {
  vehicle: 'vehicle-comparison-preview-panel__vehicles-vehicle',
};

const tooltipOptions = {
  templateId: 'tippy-template',
  targetSelector: '.vehicle-comparison-checkbox[aria-disabled="true"]',
};

const groupTitleMapping = {
  rv: 'RVs',
  'cars-trucks-suvs-vans': 'Vehicles',
  trucks: 'Trucks',
  'horse-trailers': 'Trailers',
  'livestock-trailers': 'Trailers',
  'horse-livestock-trailers': 'Trailers',
  trailers: 'Trailers',
};

export {
  classes, groupTitleMapping, selectors, tooltipOptions,
};
